import styled from 'styled-components'
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';

const Container=styled.div`
 
 
 `;


export default function VerticaStepper(props){
	
	
	return(
		<Container>

				<Box >
     				<Stepper activeStep={props.step} orientation="vertical">
						{props.pasos.map((paso) => (
							<Step key={paso.Ruta_Tutorial.paso } >
							 	<StepLabel optional={props.totalSteps ===paso.Ruta_Tutorial.paso ?(<Typography variant="caption">ultimo paso</Typography>) : null}>
							 		{paso.name}
								</StepLabel> 
							</Step>) )
						}						
					</Stepper>
				</Box>



		</Container>





		)
}